import Mgr from '../../SecurityService'
import axios from "axios";

var mgr = new Mgr();

const state = {
    Notifications: [],
};

const getters = {
    getNotifications: state => state.Notifications
};

const actions = {
    async loadNotifications({ commit }) {
        let userName = await mgr.getUsername();
        let response = await axios.get(`/api/Notification?inboxId=${userName}&PageNumber=1&PageSize=-1`);
        if(response.ok) {
            commit('setNotifications', response.data);
        }
    },
    async toggleAckNotification({ commit }, id){
        let response = await axios.patch(`/api/Notification?inboxNotificationId=${id}`);
        if(response.ok) {
            commit('replaceNotification', response.data);
        }
    },
    async deleteNotification({ commit }, id){
        let response = await axios.delete(`/api/Notification?inboxNotificationId=${id}`);
        if(response.ok) {
            commit('deleteNotification', response.data);
        }
    }
}

const mutations = {
    setNotifications: (state, Notifications) => (state.Notifications = Notifications),
    replaceNotification: (state, Notification) => {
        state.Notifications = state.Notifications.map(obj => [Notification].find(o => o.id === obj.id) || obj);
    },
    deleteNotification: (state, Notification) => {
        state.Notifications = state.Notifications.filter(item => item.id != Notification.id);
    }
};
  
export default { state, getters, actions, mutations };
  